import { useServices } from '@/app/providers';
import { usePaginatedList } from '@/shared/hooks';
import type { Routine, RoutineCategory } from '@yawi/types';

interface RoutineFilters {
  category?: RoutineCategory | '';
  enabled?: '' | 'true' | 'false';
}

export function useRoutineList() {
  const { routineRepo } = useServices();

  return usePaginatedList<Routine, RoutineFilters>({
    fetchFn: (params) => {
      const { category, enabled, ...rest } = params as typeof params & RoutineFilters;
      return routineRepo.list({
        ...rest,
        category: category || undefined,
        enabled: enabled === 'true' ? true : enabled === 'false' ? false : undefined,
      });
    },
    initialFilters: { category: '', enabled: '' },
    errorTitle: 'Error al cargar rutinas',
  });
}
